import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '10px',
  },
  led: {
    margin: '0 auto',
    width: (props: any) => (props.circular ? '34px' : '24px'),
    border: '0.1px solid white',
    marginBottom: '5px',
    borderRadius: (props: any) => (props.circular ? `50%` : `3px`),
    height: (props: any) => (props.circular ? `34px` : `6px`),
  },
  green: {
    backgroundColor: '#7dbb01',
  },
  red: {
    backgroundColor: '#F00',
  },
  yellow: {
    backgroundColor: '#FF0',
  },
  ledOn: {
    boxShadow: 'rgba(0, 0, 0, 0.2) 0 0 7px 1px, white 0 0px 12px',
  },
  text: {
    fontSize: '8px',
    color: 'white',
  },
});

interface ILedProps {
  circular?: boolean;
  text?: string;
  ledOn?: boolean;
  className?: string;
  offColor: string;
  onColor?: string;
}

const LedIndicator = styled.div<any>`
  background-color: ${({ offColor, ledOn, onColor }) => {
    if (ledOn && onColor) {
      return onColor;
    }
    switch (offColor) {
      case 'GREEN':
        return '#7dbb01';
      case 'RED':
        return '#F00';
      case 'YELLOW':
        return '#FF0';
      default:
        return offColor || '#7dbb01';
    }
  }};
`;

const Led: React.FunctionComponent<ILedProps> = ({
  circular = false,
  text,
  ledOn = false,
  className,
  offColor,
  onColor,
}) => {
  const classes = useStyles({ circular });
  return (
    <div className={clsx(classes.root, className)}>
      <LedIndicator
        className={clsx(classes.led, ledOn && classes.ledOn)}
        offColor={offColor}
        ledOn={ledOn}
        onColor={onColor}
      ></LedIndicator>
      {text && <span className={classes.text}>{text}</span>}
    </div>
  );
};

export default Led;
